import { render, staticRenderFns } from "./contentInfo.vue?vue&type=template&id=5e7fc731&scoped=true&"
import script from "./contentInfo.vue?vue&type=script&lang=js&"
export * from "./contentInfo.vue?vue&type=script&lang=js&"
import style0 from "./contentInfo.vue?vue&type=style&index=0&id=5e7fc731&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7fc731",
  null
  
)

export default component.exports